import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from '@services/entity/users.service';
import { plainToClass } from 'class-transformer';
import { empty, Observable, of, pipe } from 'rxjs';
import { map, filter, tap, finalize } from 'rxjs/operators'
import '@angular/localize/init';
import Swal from 'sweetalert2';
import { ChargingStationsService } from '../../../../services/entity/charging-stations.service';
import { ToastService } from '../../../../services/toast/toast.service';
import { ChargingStationDto } from '../../../../dto/chargingStationDto';
import { FilesService } from '../../../../services/files/files.service';
import { FormService } from '../../../../services/form/form.service';

@Component({
  selector: 'update-charging-stations-dialog-content',
  templateUrl: './update-charging-stations-dialog-content.html',
  styleUrls: ['./update-charging-stations-dialog-content.scss']
})

export class UpdateChargingStationsDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'UpdateChargingStationsDialogContentComponent';
  public updateReady: boolean = false;
  public loading: boolean = false;
  public chargingStations: ChargingStationDto[];

   constructor(
    public activeModal: NgbActiveModal,
     private chargingStationsService: ChargingStationsService,
     private filesservice: FilesService,
     private formService: FormService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    this.chargingStationsService.getAllChargingStations().subscribe(
      stations => {
        this.chargingStations = plainToClass(ChargingStationDto, stations)
        // this.chargingStations = stations.filter(x => x.status.id == 2).filter(k => k.firmware != null).sort(function (a, b) {
        //   var textA = a.name.toUpperCase();
        //   var textB = b.name.toUpperCase();
        //   return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        // });
        this.mapStatus()
      }
    ), error => {}
    super.ngOnInit();
    this.loading = true;
  }
  
  uploadChargingStationFirmware() {
    //this.filesservice.upload(this.formService.form.get(''))
  }

  createForm() {

  }

  updateChargingStations() {
  }

  closeModal() {
    this.activeModal.close();
  }


  openSuccessDialog() {
    Swal.fire({
      title: $localize`:@@DeliveryNoteSendedHeader:Versenden erfolgreich`,
      text: $localize`:@@DeliveryNoteSendedText:Die E-Mail wurde erfolgreich verschickt.`,
      icon: 'success',
      confirmButtonText: $localize`:@@OkButton:OK`,
      confirmButtonColor: 'green',
    }).then((result) => {
      //this.initializeEntities();
    });
  }

  mapStatus() {
    this.chargingStations.forEach(e => {
      let displayStatus = ""
      for (const chargingPoint of e.chargingPoints) {
        const badgeColor = this.getBadgeColor(chargingPoint.statusId)
        displayStatus += `<span class="badge rounded-pill ${badgeColor} connector-id-${chargingPoint.connectorId}">${chargingPoint.status.name}</span>`
      }

      e.displayStatus = displayStatus;
    })
  }

  getBadgeColor(statusId) {
    switch (statusId) {
      case 1: return 'bg-primary';
      case 2: return 'bg-success';
      case 3: return 'bg-warning';
      case 4: return 'bg-danger';
      case 5: return 'bg-info';
      case 6: return 'bg-info';
      case 7: return 'bg-reserved';
      case 8: return 'bg-info';
      case 9: return 'bg-info';
      case 10: return 'bg-danger';
      case 11: return 'bg-secondary';
      default: return 'bg-secondary';
    }
  }
}
